import { render, staticRenderFns } from "./selectContact.vue?vue&type=template&id=dc03fa6a&scoped=true"
import script from "./selectContact.vue?vue&type=script&lang=js"
export * from "./selectContact.vue?vue&type=script&lang=js"
import style0 from "./selectContact.vue?vue&type=style&index=0&id=dc03fa6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc03fa6a",
  null
  
)

export default component.exports